module.exports = __webpack_public_path__ + "static/media/480.b3593720.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-field/dark/480.png
// module id = 2040
// module chunks = 2